export type Work = {
  title: string;
  className?: string;
};

/**
 * 作品名
 */
export default function WorkTitle({ title, className }: Work) {
  return (
    <p
      className={`inline-block max-w-60 items-center truncate rounded-md border border-GRAY_1 px-2 py-0.5 text-sm text-GRAY_1 ${className}`}
    >
      {title}
    </p>
  );
}
